(function () {
  function initialiseShowroomBookingTest(section) {
    if (!section || section.dataset.showroomBookingInitialised === "true") return;
    section.dataset.showroomBookingInitialised = "true";

    const modal = section.querySelector("[data-showroom-booking-modal]");
    const dialog = section.querySelector("[data-showroom-booking-dialog]");
    const form = section.querySelector("[data-showroom-booking-form]");
    const closeButton = section.querySelector("[data-showroom-booking-close]");
    const submitButton = section.querySelector("[data-showroom-booking-submit]");
    const status = section.querySelector("[data-showroom-booking-status]");
    const success = section.querySelector("[data-showroom-booking-success]");
    const showroomInput = section.querySelector("[data-showroom-booking-showroom]");
    const headingShowroom = section.querySelector("[data-showroom-booking-heading-showroom]");
    const dateInput = section.querySelector("[data-showroom-booking-date]");
    const timeSelect = section.querySelector("[data-showroom-booking-time]");
    const companyInput = section.querySelector("[data-showroom-booking-company]");
    const payloadMessageInput = section.querySelector("[data-showroom-booking-payload-message]");
    const openButtons = section.querySelectorAll("[data-showroom-booking-open]");

    if (
      !modal ||
      !dialog ||
      !form ||
      !closeButton ||
      !submitButton ||
      !status ||
      !success ||
      !showroomInput ||
      !headingShowroom ||
      !dateInput ||
      !timeSelect ||
      !payloadMessageInput
    ) {
      return;
    }

    let previouslyFocusedElement = null;
    const bookingStartDate = "2026-08-20";
    const firstDayAfternoonStart = "14:00";

    function setMinimumDate() {
      const today = new Date();
      const year = today.getFullYear();
      const month = String(today.getMonth() + 1).padStart(2, "0");
      const day = String(today.getDate()).padStart(2, "0");
      const todayValue = `${year}-${month}-${day}`;
      dateInput.min = todayValue > bookingStartDate ? todayValue : bookingStartDate;
    }

    function updateTimeAvailability() {
      const afternoonOnly = dateInput.value === bookingStartDate;

      Array.from(timeSelect.options).forEach(function (option) {
        if (!option.value) return;
        option.disabled = afternoonOnly && option.value < firstDayAfternoonStart;
      });

      if (timeSelect.selectedOptions[0] && timeSelect.selectedOptions[0].disabled) {
        timeSelect.value = "";
      }
    }

    function validateAppointmentAvailability() {
      if (dateInput.value && dateInput.value < bookingStartDate) {
        dateInput.setCustomValidity("Appointments are available from the afternoon of 20 August 2026.");
      } else if (dateInput.value && !isWeekday(dateInput.value)) {
        dateInput.setCustomValidity("Please choose a Monday to Friday.");
      } else {
        dateInput.setCustomValidity("");
      }

      if (
        dateInput.value === bookingStartDate &&
        timeSelect.value &&
        timeSelect.value < firstDayAfternoonStart
      ) {
        timeSelect.setCustomValidity("Please choose an afternoon time on 20 August.");
      } else {
        timeSelect.setCustomValidity("");
      }
    }

    function resetFeedback() {
      status.textContent = "";
      status.hidden = true;
      status.style.color = "";
      form.hidden = false;
      success.hidden = true;
    }

    function openModal(button) {
      previouslyFocusedElement = button;
      const showroomName = button.dataset.showroomName || "Showroom";
      showroomInput.value = showroomName;
      headingShowroom.textContent = showroomName;
      resetFeedback();
      modal.classList.add("is-active");
      modal.setAttribute("aria-hidden", "false");
      document.body.classList.add("showroom-booking-test-is-open");
      setTimeout(function () {
        const firstField = form.querySelector("input:not([type='hidden'])");
        if (firstField) firstField.focus();
      }, 0);
    }

    function closeModal() {
      modal.classList.remove("is-active");
      modal.setAttribute("aria-hidden", "true");
      document.body.classList.remove("showroom-booking-test-is-open");
      if (previouslyFocusedElement) previouslyFocusedElement.focus();
    }

    function showStatus(message, colour) {
      status.textContent = message;
      status.hidden = false;
      status.style.color = colour || "#2b2920";
    }

    function isWeekday(value) {
      if (!value) return false;
      const selectedDate = new Date(`${value}T12:00:00`);
      const day = selectedDate.getDay();
      return day >= 1 && day <= 5;
    }

    function formatDate(value) {
      const selectedDate = new Date(`${value}T12:00:00`);
      return new Intl.DateTimeFormat("en-GB", {
        weekday: "long",
        day: "numeric",
        month: "long",
        year: "numeric"
      }).format(selectedDate);
    }

    function buildMessage() {
      const company = companyInput ? companyInput.value.trim() : "";
      const selectedTime = timeSelect.options[timeSelect.selectedIndex].text;

      return [
        "[SHOWROOM_APPOINTMENT_REQUEST]",
        "",
        `Showroom: ${showroomInput.value}`,
        `Preferred date: ${formatDate(dateInput.value)}`,
        `Preferred time: ${selectedTime}`,
        `Timezone: ${form.dataset.timezone || "Europe/London"}`,
        `Company: ${company || "Not provided"}`,
        "",
        "Calendar status: Appointment requested; not yet confirmed."
      ].join("\n");
    }

    openButtons.forEach(function (button) {
      button.addEventListener("click", function () {
        openModal(button);
      });
    });

    const requestedShowroom = new URLSearchParams(window.location.search).get(
      "book-showroom"
    );
    if (requestedShowroom) {
      const requestedButton = Array.from(openButtons).find(function (button) {
        return (
          (button.dataset.showroomName || "").trim().toLowerCase() ===
          requestedShowroom.trim().toLowerCase()
        );
      });
      if (requestedButton) openModal(requestedButton);
    }

    closeButton.addEventListener("click", closeModal);

    modal.addEventListener("mousedown", function (event) {
      if (event.target === modal) closeModal();
    });

    dialog.addEventListener("keydown", function (event) {
      if (event.key !== "Tab") return;

      const focusable = Array.from(
        dialog.querySelectorAll(
          "button:not([disabled]), input:not([disabled]):not([type='hidden']), select:not([disabled]), textarea:not([disabled]), a[href]"
        )
      ).filter(function (element) {
        return !element.closest("[hidden]");
      });

      if (!focusable.length) return;
      const first = focusable[0];
      const last = focusable[focusable.length - 1];

      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    });

    document.addEventListener("keydown", function (event) {
      if (event.key === "Escape" && modal.classList.contains("is-active")) {
        closeModal();
      }
    });

    dateInput.addEventListener("change", function () {
      updateTimeAvailability();
      validateAppointmentAvailability();
      if (!dateInput.checkValidity()) dateInput.reportValidity();
    });

    timeSelect.addEventListener("change", validateAppointmentAvailability);

    form.addEventListener("submit", function (event) {
      event.preventDefault();

      updateTimeAvailability();
      validateAppointmentAvailability();

      if (!form.checkValidity()) {
        form.reportValidity();
        return;
      }

      payloadMessageInput.value = buildMessage();
      submitButton.disabled = true;
      showStatus(form.dataset.sendingText || "Sending request…");

      const formData = new FormData(form);
      const isDevelopment =
        window.location.hostname.includes("originalbtcdev.myshopify.com") ||
        window.location.hostname.includes("127.0.0.1");
      const endpoint = isDevelopment
        ? form.dataset.developmentEndpoint
        : form.dataset.productionEndpoint;

      fetch(endpoint, {
        method: "POST",
        mode: "no-cors",
        body: formData
      })
        .then(function () {
          return new Promise(function (resolve) {
            setTimeout(resolve, 1000);
          });
        })
        .then(function () {
          form.reset();
          setMinimumDate();
          updateTimeAvailability();
          form.hidden = true;
          status.hidden = true;
          success.hidden = false;
          closeButton.focus();
        })
        .catch(function (error) {
          console.error("Showroom appointment request error:", error);
          showStatus(
            form.dataset.errorText ||
              "We could not send your request. Please try again.",
            "#9c1c1c"
          );
        })
        .finally(function () {
          submitButton.disabled = false;
        });
    });

    setMinimumDate();
    updateTimeAvailability();
  }

  function initialiseAllShowroomBookingTests(root) {
    const scope = root || document;
    if (
      scope.matches &&
      scope.matches("[data-showroom-booking-test-section]")
    ) {
      initialiseShowroomBookingTest(scope);
    }

    scope
      .querySelectorAll("[data-showroom-booking-test-section]")
      .forEach(initialiseShowroomBookingTest);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      initialiseAllShowroomBookingTests(document);
    });
  } else {
    initialiseAllShowroomBookingTests(document);
  }

  document.addEventListener("shopify:section:load", function (event) {
    initialiseAllShowroomBookingTests(event.target);
  });
})();
